export default __webpack_public_path__ + "static/8-ca19841ccb3a77fa36a4253260c002f2.png";